import React, { useEffect, useState } from "react";
import PrismaticBurst from "../PrismaticBurst";

export default function Hero() {
  const [rotation, setRotation] = useState(0);

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const newRotation = scrollTop * 0.1;
    setRotation(newRotation);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      <style>{`
        .home-section {
          position: relative;
          overflow: hidden;
          background-color: #000000;
          min-height: 100vh;
          display: flex;
          align-items: center;
          padding: var(--section-padding);
        
        }
        .hero-bg-wrapper {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
          opacity: 0.7;
          pointer-events: none;
        }
        .home-section .container {
          position: relative;
          z-index: 2;
        }
        .home-content {
          text-align: center;
        }
        .home-content h1 {
          font-family: var(--font-primary);
          font-size: var(--h1-size);
          font-weight: var(--h1-weight);
          line-height: var(--lh-tight);
          margin-bottom: var(--gap-md);
          color: #ffffff;
        }
        .title-effect span {
          color: var(--theme-color);
          display: inline-block;
          text-shadow: 0 0 30px rgba(var(--theme-color-rgb), 0.3);
        }
        .home-content h3 {
          font-family: var(--font-primary);
          font-size: var(--h3-size);
          font-weight: 500;
          margin-bottom: 32px;
          letter-spacing: 4px;
          text-transform: uppercase;
          opacity: 0.9;
        }
        .home-content p {
          font-family: var(--font-secondary);
          font-size: var(--body-size);
          max-width: 850px;
          margin: 0 auto var(--gap-lg);
          line-height: var(--lh-relaxed);
          opacity: 0.8;
        }
        .btn-solid {
          font-family: var(--font-primary);
          background: var(--theme-color);
          color: white !important;
          padding: 18px 48px;
          border-radius: 100px;
          font-weight: 700;
          font-size: 1.1rem;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          text-decoration: none;
          display: inline-block;
          border: 1px solid rgba(255, 255, 255, 0.1);
          box-shadow: 0 10px 30px rgba(var(--theme-color-rgb), 0.2);
        }
        .btn-solid:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px rgba(var(--theme-color-rgb), 0.4);
          background: #e4ae85;
        }
        .home-info p {
          font-family: var(--font-primary);
          font-size: 1.1rem;
          letter-spacing: 2px;
          text-transform: uppercase;
          opacity: 0.5;
          margin-top: 60px;
        }
      `}</style>
      <section className="home-section" >
        <div className="hero-bg-wrapper">
          <div style={{ width: '100%', height: '100%', position: 'relative' }}>
            <PrismaticBurst
              animationType="rotate3d"
              intensity={2}
              speed={0.5}
              distort={0}
              paused={false}
              offset={{ x: 0, y: 0 }}
              hoverDampness={0.25}
              rayCount={0}
              mixBlendMode="lighten"
              colors={['#D1986D', '#B7794F', '#8F6A5A']}
              color0="#D1986D"
              color1="#B7794F"
              color2="#8F6A5A"
            />
          </div>
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              <div className="home-content" style={{ marginTop: "100px" }}>
                <div className="bg-effect">
                  {/* Images removed as requested */}
                </div>
                <div>
                  <h1>
                    Unleash Smart Financial Growth with
                    {/* <div className="title-effect" style={{ backgroundColor: "#fff" }}> */}
                    {/* Image removed as requested */}
                    <span style={{ color: "#D1986D" }}> AGN</span>
                    {/* </div>{" "} */}
                  </h1>
                  <h3 className="text-white">Adonai Group of Network
                  </h3>
                  <p className="text-white">
                    AGN combines Asset-Based Finance and Market Trading Mechanisms to create a powerful ecosystem for passive income, liquidity, and scalable growth.

                  </p>

                  <div className="d-flex justify-content-center">
                    <a
                      href="https://app.agnadonai.com/"
                      data-cursor="pointer"
                      target="_blank"
                      className="btn-solid text-center mt-3"
                    >
                      Get Started
                    </a>
                  </div>
                </div>
              </div>
              <div className="home-laptop px-md-0 px-3">
                <div className="laptop-sec position-relative">
                  <div className="hand-sec">
                    {/* Images removed as requested */}
                  </div>
                  {/* Laptop image removed as requested */}
                </div>
                <div className="home-info text-center">
                  <ul className="info-list list-unstyled">
                    <p className="text-white">
                      Balanced. Structured. Opportunity-Driven.

                    </p>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
